/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Existing_MsgInputs */

const es_cap_err_existing_msg = /** @type {(inputs: Cap_Err_Existing_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya hay una cuenta con este correo. Inicia sesión para solicitar tu perfil de capitán.`)
};

const gl_cap_err_existing_msg = /** @type {(inputs: Cap_Err_Existing_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xa hai unha conta con este correo. Inicia sesión para solicitar o teu perfil de patrón.`)
};

const en_cap_err_existing_msg = /** @type {(inputs: Cap_Err_Existing_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An account with this email already exists. Sign in to request your skipper profile.`)
};

/**
* | output |
* | --- |
* | "An account with this email already exists. Sign in to request your skipper profile." |
*
* @param {Cap_Err_Existing_MsgInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_existing_msg = /** @type {((inputs?: Cap_Err_Existing_MsgInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Existing_MsgInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_existing_msg(inputs)
	if (locale === "en") return en_cap_err_existing_msg(inputs)
	return es_cap_err_existing_msg(inputs)
});